import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Checkbox,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import TablePagination from '@material-ui/core/TablePagination';
import Actions from './actions';
import TableHeader from 'src/components/shared/TableHeader';

const TableFooters = ({
  className, auth, data, currentPage, itemsCountPerPage, totalItemsCount, prevPage, nextPage, lastPage, loading, ...rest
}) => {
  const handlePageChange = (event, page) => {
    rest.getAllFooters(page + 1, parseInt(itemsCountPerPage))
  };

  const handleChangeRowsPerPage = (event) => {
    rest.getAllFooters(1, event.target.value)
  };

  const renderLinkCell = (footer) => {

    switch (footer.link_type) {
      case 'url':
        return footer.link;
      case 'institutional':
        return footer.institutional_page.link;
      case 'front_page':
        return `${process.env.REACT_APP_JUANAMANSO_REA}${footer.front_page.slug}`;
      default:
        return `${process.env.REACT_APP_JUANAMANSO_REA}#REA`;
    }
  };

  return (
    <Card
      className={className}
    >
      <PerfectScrollbar>
        <Box minWidth={1050}>
          <Typography variant="subtitle1" className="mt-3 ml-3 mb-2">
            Listado de Pies de página
            {
              loading &&
              <CircularProgress size={24} style={{ marginLeft: 15 }} />
            }
          </Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableHeader property="id">ID</TableHeader>
                <TableHeader property="name">Nombre</TableHeader>
                <TableHeader property="order">Orden</TableHeader>
                <TableHeader property="link">Enlace</TableHeader>
                <TableHeader property="active">Activo</TableHeader>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((footer) => (
                <TableRow
                  hover
                  key={footer.id}
                >
                  <TableCell>
                    {footer.id}
                  </TableCell>
                  <TableCell>
                    {footer.name}
                  </TableCell>
                  <TableCell>
                    {footer.order}
                  </TableCell>
                  <TableCell>
                    {renderLinkCell(footer)}
                  </TableCell>
                  <TableCell>
                    <Checkbox
                      checked
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                      disabled
                      indeterminate={!footer.active}
                      style={{ color: footer.active ? 'green' : 'red' }}
                    />
                  </TableCell>
                  <TableCell>
                    <Actions footer={footer} deleteFooter={rest.deleteFooter} authPermissions={auth.permissions} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      {
        data.length === 0 &&
        <div className="text-center mt-2" >
          No hay resultados para su búsqueda
        </div>
      }
      <TablePagination
        component="div"
        className="paginador"
        count={totalItemsCount}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleChangeRowsPerPage}
        page={currentPage - 1}
        rowsPerPage={parseInt(itemsCountPerPage)}
        rowsPerPageOptions={[5, 10, 20]}
        labelRowsPerPage="Filas por página"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Card>
  );
};

export default TableFooters;
